import React from "react";

import "./App.scss";
import Navbar from "./components/Navbar/Navbar";
import Header from "./container/Header/Header";
import About from "./container/About/About";
import Skills from "./container/Skills/Skills";
import Projects from "./container/Projects/Projects";
import Contact from "./container/Contact/Contact";

export default function App() {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Skills />
      <Projects />
      <Contact />
    </div>
  );
}
